<!--CONTENIDO ITEM DATOS DETALLE INCONFORMIDAD-->
<ng-container>
  <div class="wrapper__form">
      <div class="row align-items-center">
        <app-form
          [fields]="formFields"
          [withSubmitButton]="false"
          (changeAction)="validateForm($event)"
          (changedControl)="validarFormulario($event)"
          [idEntidad]="entidadId">
        </app-form>
      </div>
      <div class="row align-items-center">
        <app-form
          id="formTramite"
          [fields]="formFieldsTramite"
          [withSubmitButton]="false"
          (changeAction)="onSubmitTramite($event)"
          (changedControl)="validarFormularioTramite($event)"
          [idEntidad]="entidadId">
        </app-form>
      </div> 
      <div class="wrapper__form">
        <div class="col-12 col-xl-12 mb-3">
          <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(4).length > 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(4)"
                    [paso]="4"
                    [idTipoTramite]="entidadId"
                    [idTramite]="tramiteSfc?.id!"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    [enviarEntidad]="enviar"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, 4)"
                    [nombreCortoTramite]="nombreTramite">
             </app-cargue-archivos-tramite>
             <app-cargue-archivos-tramite
                    *ngIf="getFilesPrecargadosByPaso(4).length == 0"
                    [archivosPreCargados]="getFilesPrecargadosByPaso(4)"
                    [paso]="4"
                    [idTipoTramite]="entidadId"
                    [idTramite]="tramiteSfc?.id!"
                    [btnEnviar]="false"
                    [enviar]="enviarDocumentos"
                    [enviarEntidad]="enviar"
                    (archivosObligatoriosPasos)="getFileRequeridos($event)"
                    (guardo)="subirArchivo($event)"
                    (archivosCargados)="validarArchivosCargados($event, 4)"
                    [nombreCortoTramite]="nombreTramite">
             </app-cargue-archivos-tramite>
            <div class="mt-3 text-muted small d-flex align-items-center">
              <i class="bi bi-info-circle me-2"></i>
              {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
            </div>
        </div>
      </div>  
      <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
        <div class="d-flex flex-column flex-md-row gap-2">
          <button
            type="submit"
            class="btn-govco fill-before-btn-govco w-auto"
            onClick="nextItemAdvanceLineIHorizonalBack(event)"
            (click)="atras()"
            [attr.aria-label]="sfcText['botones-envio']['atras']">
            {{ sfcText['botones-envio']['atras'] }}
          </button>
          <button
            type="submit"
            class="btn-govco fill-btn-govco  w-auto"
            (click)="pasarAReclamo($event, true)"
            [attr.aria-label]="sfcText['botones-envio']['guardar-sin-enviar']">
            {{ sfcText['botones-envio']['guardar-sin-enviar'] }}
          </button>
          <button
            type="submit"
            class="btn-govco fill-next-btn-govco w-auto"
            (click)="pasarAReclamo($event, false)"
            [attr.aria-label]="sfcText['siguiente']">
            {{ sfcText['siguiente'] }}
          </button>
        </div>
      </div>
  </div>
</ng-container>